var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23,
    fill: "white",
    stroke: "#58E866"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7344 22C25.4958 22 27.7344 19.7614 27.7344 17C27.7344 14.2386 25.4958 12 22.7344 12C19.973 12 17.7344 14.2386 17.7344 17C17.7344 19.7614 19.973 22 22.7344 22Z",
    stroke: "#ACACAC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7344 32H16.0004C15.7168 32.0001 15.4364 31.9398 15.1779 31.8232C14.9193 31.7066 14.6885 31.5364 14.5008 31.3238C14.3131 31.1112 14.1727 30.8611 14.089 30.5901C14.0054 30.3191 13.9803 30.0334 14.0154 29.752L14.4054 26.628C14.4961 25.9022 14.8489 25.2346 15.3973 24.7506C15.9457 24.2667 16.652 23.9997 17.3834 24H17.7344",
    stroke: "#ACACAC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7344 26L28.9844 28L32.7344 24",
    stroke: "#58E866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCreate);
export default __webpack_public_path__ + "static/media/accountCreate.5a962b69c780aa24836faf82783d1fe6.svg";
export { ForwardRef as ReactComponent };